import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const TableCenteredCell = ({ as: Tagname = 'td', className, ...props }) => (
  <Tagname className={classNames('table-component__centered-cell', className)} {...props} />
);

TableCenteredCell.propTypes = {
  as: PropTypes.string,
  className: PropTypes.string,
};

export default TableCenteredCell;
